"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = parseInitResponse;
const jsonito_1 = require("jsonito");
const shared_1 = require("../shared");
function parseInitResponse(response) {
    if (response.startsWith(shared_1.jsonitoResponsePrefix)) {
        return (0, jsonito_1.parse)(response.slice(shared_1.jsonitoResponsePrefix.length));
    }
    return JSON.parse(response);
}
//# sourceMappingURL=parseInitResponse.js.map